import * as yup from 'yup'

export const validationDomainDashboard = yup.object({
  dominio: yup
    .string()
    .required('Este campo es obligatirio')
    .max(8, 'No se puede ingresar mas de 8 caracteres'),
})
